import { render, staticRenderFns } from "./login-register-dialog.vue?vue&type=template&id=4433057b&scoped=true"
import script from "./login-register-dialog.vue?vue&type=script&lang=js"
export * from "./login-register-dialog.vue?vue&type=script&lang=js"
import style0 from "./login-register-dialog.vue?vue&type=style&index=0&id=4433057b&prod&lang=scss&scoped=true"
import style1 from "./login-register-dialog.vue?vue&type=style&index=1&id=4433057b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4433057b",
  null
  
)

export default component.exports